import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

import { markdown } from 'markdown';



const OtherOptionsItem = props => {
  const [checked, setChecked] = useState(props.value);

  useEffect(() => {
    setChecked(props.value);
  }, [props.value]);

  const handleToggle = (e) => {
    e.preventDefault();
    const {
      otherOptionCode,
      updateOtherOption,
      otherOptionSaveBody,
      showNotification,
      fetchActivities,
      calendarStartDateStr,
      calendarEndDateStr
    } = props;

    const currentInputCheckedValue = checked;
    const newInputCheckedValue = !currentInputCheckedValue;

    otherOptionSaveBody.value = newInputCheckedValue;

    const {
      bidSessionId,
      categoryId,
      staffId,
    } = otherOptionSaveBody;

    updateOtherOption(otherOptionCode, otherOptionSaveBody)
      .then((response) => {
        const vacationsReseted = response.data.vacationsReseted || false;
        const refreshCalendar = response.data.refreshCalendar || false;

        setChecked(newInputCheckedValue);
        
        // Notify parent component that an option was toggled
        if (props.onOptionToggled) {
          props.onOptionToggled(otherOptionCode, newInputCheckedValue);
        }

        if (vacationsReseted && response.data.message) {
          showNotification(response.data.message);
        }
        if (refreshCalendar) {
          fetchActivities(
            staffId,
            calendarStartDateStr,
            calendarEndDateStr,
            bidSessionId,
            categoryId,
          );
        }
      })
      .catch((error) => {
        setChecked(currentInputCheckedValue);
        if (error.response && error.response.data && error.response.data.message) {
          showNotification(error.response.data.message);
        } else {
          showNotification('An error occurred. Please try again.');
        }
      });
  };

  const theme = createTheme({
    overrides: {
      MuiSwitch: {
        switchBase: {
          // Controls default (unchecked) color for the thumb
          color: "#fff"
        },
        colorPrimary: {
          "&$checked": {
            // Controls checked color for the thumb
            color: "#009688"
          }
        },
        track: {
          // Controls default (unchecked) color for the track
          backgroundColor: "#ADADAD",
          "$checked$checked + &": {
            // Controls checked color for the track
            opacity: 0.4,
            backgroundColor: "#009688"
          }
        }
      }
    }
  });

  const inputProps = {
    color:"primary",
    checked: checked,
    onChange: handleToggle,
  };
  return (
    <ThemeProvider theme={theme}>
      <div className="row expanded item-row">
        <div className="column medium-1 toggle">
          <div>
            <Switch disabled={props.readOnly} {...inputProps} />
          </div>
        </div>
        <div className="column medium-11">
          <div className="option-item">
            <span className={`title ${checked ? 'checked' : ''}`}>{props.title}</span>
            <span className={`title ${checked ? 'checked' : ''}`}>{props.subtitle}</span>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

OtherOptionsItem.propTypes = {
  calendarStartDateStr: PropTypes.any,
  calendarEndDateStr: PropTypes.any,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.bool.isRequired,
  otherOptionCode: PropTypes.number.isRequired,
  otherOptionSaveBody: PropTypes.object.isRequired,
  updateOtherOption: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  fetchActivities: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onOptionToggled: PropTypes.func
};

OtherOptionsItem.defaultProps = {
  calendarStartDateStr: null,
  calendarEndDateStr: null,
  subtitle: '',
  onOptionToggled: null
};

export default OtherOptionsItem;
